import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Authenticate, AuthResponse } from '../models/auth'

import { environment } from '../../../environments/environment'
import { first, map, share } from 'rxjs/operators';
import { select, Store } from '@ngrx/store';
import * as fromAuth from '../reducers';
import * as auth from '../actions/auth.actions';

const loginUrl = '/auth/login'
const refreshUrl = '/auth/token'
const meUrl = '/me'

@Injectable()
export class AuthService {

  constructor(private http: HttpClient, private store: Store<any>) { }

  login(authRequest: Authenticate) {
    return this.http.post<AuthResponse>(
      environment.baseApiUrl + loginUrl, 
      authRequest
    )
  }

  getToken(): Observable<string> {
    return this.store.pipe(select(fromAuth.getToken),
      first()
    )
  }

  refreshToken(refreshToken: string): Observable<AuthResponse> {
      return this.http.get<AuthResponse>(
        environment.baseApiUrl + refreshUrl,
        { headers: new HttpHeaders().set('Authorization', `JWT ${refreshToken}`) }
      )
        .pipe(
          map(data => {
            this.store.dispatch(new auth.SetToken(data && data.token))
            return data
          }),
          share()
        )
  }

  logout() {
    return of(true)
  }
}
